import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  ApiService,
  IListData,
  IListParams,
} from 'src/app/shared/services/api/api/api.service';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { ToasterService } from 'src/app/shared/services/toaster/toaster.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompaniesComponent implements OnInit {
  @ViewChild('customContent') private _customContent;
  companies = [];
  formCompanies: UntypedFormGroup = this._formBuilder.group({
    name: ['', [Validators.required]],
    sections: this._formBuilder.array([]),
  });

  submitType = 'Add';
  totalCompanies = 0;
  limit = 50;
  skip = 0;
  search = '';
  sectionValues = [];
  constructor(
    private _api: ApiService,
    private _formBuilder: UntypedFormBuilder,
    private _cdr: ChangeDetectorRef,
    private _toast: ToasterService,
    private _modalService: NgbModal,
  ) {}

  ngOnInit(): void {
    this.getCompanies();
  }

  getCompanies(): void {
    const query: IListParams = { limit: this.limit, skip: this.skip };

    if (this.search) {
      query.search = this.search;
    }

    this._api.getCompanies(query).subscribe(
      (data: IListData) => {
        this.companies = data.list;
        this.totalCompanies = data.totalCount;
        this._cdr.detectChanges();
      },
      (err) => {
        console.log(err);
        this._toast.showError(err.error.message);
      },
    );
  }

  addCompany(): void {
    this.resetForm();
    this.submitType = 'Add';
    this._modalService.open(this._customContent, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      size: 'lg',
    });
  }

  resetForm(): void {
    this.companySections.clear();
    this.formCompanies.reset();
    this.formCompanies.removeControl('_id');
  }
  submitCompany(): boolean {
    console.log(this.formCompanies.value, 'hello');

    if (this.submitType === 'Add') {
      this._api.addCompany(this.formCompanies.value).subscribe(
        (): void => {
          this.getCompanies();
          this.clearData();
          this._toast.showSuccess('Company Updated Successfully');
        },
        (err) => {
          console.log(err);
          this._toast.showError(err.error.message);
        },
      );
    } else if (this.submitType === 'Edit') {
      this._api.editCompany(this.formCompanies.value).subscribe(
        (): void => {
          this._toast.showSuccess('Company edited successfully');
          this.getCompanies();
          this.clearData();
        },
        (err) => {
          this._toast.showError(err.error.message);
        },
      );
    }

    return false;
  }

  editCompany(companyIndex): void {
    const company = this.companies[companyIndex];
    this.resetForm();
    this.submitType = 'Edit';
    this.formCompanies.controls.name.patchValue(company.name);
    this.formCompanies.addControl('_id', new UntypedFormControl(company._id));
    this.formCompanies.setControl(
      'sections',
      this._formBuilder.array(this.populateEditValues(company.sections)),
    );
    this._modalService.open(this._customContent, {
      windowClass: 'dark-modal',
      backdrop: 'static',
      size: 'lg',
    });
  }

  deleteCompany(company): void {
    this._api.deleteCompany(company).subscribe(
      (): void => {
        this._toast.showSuccess('Company deleted successfully');
        this.getCompanies();
      },
      (err) => {
        this._toast.showError(err.error.message);
      },
    );
  }

  loadPageData(data): void {
    this.skip = data.index;
    this.search = data.search ? data.search : '';
    this.getCompanies();
  }

  get companySections(): UntypedFormArray {
    return this.formCompanies.get('sections') as UntypedFormArray;
  }

  addSection(): void {
    this.companySections.push(new UntypedFormControl(''));
  }

  removeSection(i): void {
    this.companySections.removeAt(i);
    this.formCompanies.markAsDirty();
  }

  populateEditValues(editSections = []): any[] {
    const incomingSectionsForm = [];
    editSections.forEach((sec) => {
      incomingSectionsForm.push(new UntypedFormControl(sec || ''));
    });
    return incomingSectionsForm;
  }

  clearData(): void {
    this._api.clearPathData('company');
  }
}
